import type { AdminErrorLogsResponseDto, AdminUsersResponseDto } from '../dto/admin';
import { httpArg, httpGet, httpPost, httpRoute, httpUserId } from '../infrastructure/http/http-decorators';

@httpRoute('/api/admin')
export abstract class IAdminService {
	@httpGet('get-users')
	getUsers(
		@httpArg('page') page: number,
		@httpArg('limit') limit: number,
		@httpUserId() userId?: string
	): Promise<AdminUsersResponseDto> {
		void page;
		void limit;
		void userId;
		throw new Error('Not implemented');
	}

	@httpGet('get-error-logs')
	getErrorLogs(
		@httpArg('date') date: string,
		@httpArg('limit') limit: number,
		@httpUserId() userId?: string
	): Promise<AdminErrorLogsResponseDto> {
		void date;
		void limit;
		void userId;
		throw new Error('Not implemented');
	}

	@httpPost('activate-premium')
	activatePremium(
		@httpArg('targetUserId') targetUserId: string,
		@httpArg('durationDays') durationDays: number,
		@httpUserId() userId?: string
	): Promise<void> {
		void targetUserId;
		void durationDays;
		void userId;
		throw new Error('Not implemented');
	}
}


